var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _path8, _path9, _path10, _circle2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _circle3, _circle4, _circle5, _path20, _path21, _path22, _path23;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFixingBugs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 690 448.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M211.8 420.1c4.7-10 9.3-20.3 11.4-31.2s1.1-22.8-4.7-32.3-17.2-15.9-28-13.8c-9 1.8-16.2 8.9-20.4 17s-6 17.2-7.6 26.2c-.5-10.2-1-20.6-4.5-30.2s-10-18.6-19.5-22.4-22-.8-27 8.1c-7 12.6 2.4 30.2-5.7 42-1.4-11.9-13.9-21.3-25.7-19.4S59.4 379 61.8 390.6c1.5 7 6.2 13 12 17.3s12.3 9.3 18.8 12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M68 372.5c9.4 3.3 19 6.7 27.5 11.8a50.7 50.7 0 0 1 18.9 18.7 33.4 33.4 0 0 1 4.1 14c0 1 1.7 1 1.6 0-.5-9.2-5-17.4-11-24a70.1 70.1 0 0 0-24.4-16c-5.4-2.2-10.8-4-16.3-6-1-.3-1.3 1.2-.4 1.5ZM122.3 335a143.4 143.4 0 0 1 13.8 30.6 145.1 145.1 0 0 1 6.3 33 143.3 143.3 0 0 1 .2 18.8c0 1 1.5 1 1.6 0a145.2 145.2 0 0 0-2-33.8 147 147 0 0 0-9.8-32.4 143.3 143.3 0 0 0-8.7-17 .8.8 0 0 0-1.4.8ZM200.2 344.1a232 232 0 0 0-17.1 57.6q-1.4 8.4-2.1 16.8c-.1 1 1.5 1 1.6 0a231.2 231.2 0 0 1 12.7-58q2.9-7.9 6.3-15.5c.4-1-1-1.8-1.4-.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "m482.3 432 .2 9.8-46.6.6-.2-9.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M499 444h-6.6l-4.1-7.4 4.4-7.3h6.2a12 12 0 1 0 .1 14.7ZM419.2 444h6.7l4-7.4-4.4-7.3h-6.2a12 12 0 1 1 0 14.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M689 421H1a1 1 0 0 1 0-2h688a1 1 0 0 1 0 2Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 540.5,
    cy: 198,
    r: 33,
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb8b8",
    d: "m553.9 383.2 2.5 12 47.5-4.1-3.8-17.7-46.2 9.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "m550.2 420.7-8-37.7 14.5-3 5 23a14.9 14.9 0 0 1-11.5 17.7Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb8b8",
    d: "m524.1 382.6-5.3 11-45.1-15.3 7.9-16.3 42.5 20.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "m511.8 400 10.3-21.3 13.4 6.5-16.8 34.7a14.9 14.9 0 0 1-6.9-20Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb8b8",
    d: "M435.3 360.8a10.7 10.7 0 0 0 12.7-10.5l74.3-68.6-18.4-14.3-67.4 72a10.8 10.8 0 0 0-1.2 21.4Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 536.3,
    cy: 207.9,
    r: 24.6,
    fill: "#ffb8b8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#08d9bc",
    d: "M558.4 352.3c-17.2 0-38-3.7-50.8-18.5l-.3-.3.3-.4c.1 0 9.5-10.8.1-30l-12.9 4-12.9-17 7.2-21.4 29.1-23.5a26.8 26.8 0 0 1 14.6-5.8 80.2 80.2 0 0 0 27.8-8 28 28 0 0 1 12.8-2.7h.6a10 10 0 0 1 9.6 10.7c-2 25.6-5.4 87.5 4.8 108.9l.3.5-.6.2a136.1 136.1 0 0 1-29.7 3.3Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M511 333.5s-65-6-72 13 1 28 13 32 41 9 41 9l13-16 34 2s37.9 22 48.3 45.4a30.8 30.8 0 0 0 25.8 18.3c8.4.6 15.9-2.6 15.9-15.7 0-30-42-73-42-73Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M461.5 363s17-5 44 8M511.8 192.2a73 73 0 0 0 31.6 10.4l-3.3-4a24.5 24.5 0 0 0 7.6 1.6 8.3 8.3 0 0 0 6.7-3.2 7.7 7.7 0 0 0 .5-7.1 14.6 14.6 0 0 0-4.6-5.8 27.3 27.3 0 0 0-25.4-4.5 16.3 16.3 0 0 0-7.6 4.9 9.2 9.2 0 0 0-1.8 8.5M540.3 172.6a75.5 75.5 0 0 1 19.1-26.5c5.3-4.7 11.5-8.8 18.5-10s14.8.9 19.1 6.5c3.5 4.6 4.2 10.8 3.8 16.6s-1.7 11.5-1.6 17.3a35.5 35.5 0 0 0 50.5 31.3c-6 3.4-10.7 8.6-16.3 12.6s-13 6.8-19.3 4.2c-6.7-2.9-9.8-10.5-12.2-17.3l-10.7-30.7c-1.8-5.2-3.8-10.5-7.5-14.6s-9.7-6.6-14.9-4.5c-3.8 1.5-6.4 5.2-8.6 8.8s-4.5 7.3-8.3 9.2-9.3.7-10.5-3.3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "m532.7 328.3 7-7.1 33.3 32.5-7 7.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M566.5 354.3a9.9 9.9 0 1 0 14-.2 9.9 9.9 0 0 0-14 .2Zm10.1 9.8a4.2 4.2 0 1 1 0-6 4.2 4.2 0 0 1 0 6ZM529.5 308l4.7 4.6-2.3 8.1-8.3 2-4.4-4.3a12 12 0 1 0 10.3-10.5Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb8b8",
    d: "M548.7 352.4a11.6 11.6 0 0 1-1.2-.1 11 11 0 0 1-9.7-9.7 11 11 0 0 1 11-12.2 10.6 10.6 0 0 1 1.4 0l33.6-35.7-3.5-11.7 17.6-7.9 4.9 12.1a20.5 20.5 0 0 1-6.2 23.7l-37 29.4a10.3 10.3 0 0 1 .1 1 11 11 0 0 1-3.6 8.3 10.9 10.9 0 0 1-7.4 2.8Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#08d9bc",
    d: "M575 233.5a9.5 9.5 0 0 1 12.6 5.1l17.4 43.9-27 18Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M448.5 243.7V25.3A25.3 25.3 0 0 0 423.2 0H80a25.3 25.3 0 0 0-25.3 25.3v218.4A25.3 25.3 0 0 0 80 269h343.2a25.3 25.3 0 0 0 25.3-25.3ZM80 266a22.3 22.3 0 0 1-22.3-22.3V25.3A22.3 22.3 0 0 1 80 3h343.2a22.3 22.3 0 0 1 22.3 22.3v218.4a22.3 22.3 0 0 1-22.3 22.3Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M445.5 39.3H57.7a1.5 1.5 0 1 1 0-3h387.8a1.5 1.5 0 0 1 0 3Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.9,
    cy: 20.8,
    r: 7.4,
    fill: "#08d9bc"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.2,
    cy: 20.8,
    r: 7.4,
    fill: "#08d9bc"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.5,
    cy: 20.8,
    r: 7.4,
    fill: "#08d9bc"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M189 199.2a1 1 0 0 1-1-1c0-10.4-4.6-16.2-12-22.2a1 1 0 1 1 1.3-1.6c7.8 6.4 12.7 12.6 12.7 23.8a1 1 0 0 1-1 1ZM103.3 199.2a1 1 0 0 1-1-1c0-11.2 4.9-17.4 12.7-23.8a1 1 0 1 1 1.3 1.6c-7.4 6-12 11.8-12 22.2a1 1 0 0 1-1 1ZM180.4 130.7a1 1 0 0 1-.6-1.8c7.6-6.1 8.2-15 8.2-24.9a1 1 0 0 1 2 0c0 10.5-.7 19.8-9 26.5a1 1 0 0 1-.6.2ZM111.9 130.2a1 1 0 0 1-.6-.3c-8.3-6.7-9-15.7-9-25.9a1 1 0 0 1 2 0c0 10 .6 18.2 8.2 24.4a1 1 0 0 1-.6 1.8ZM201.8 152.2h-21.4a1 1 0 0 1 0-2h21.4a1 1 0 1 1 0 2ZM111.9 152.2H90.5a1 1 0 0 1 0-2h21.4a1 1 0 0 1 0 2ZM146.1 195a1 1 0 0 1-1-1v-68.6a1 1 0 0 1 2 0V194a1 1 0 0 1-1 1Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M146.1 195a35.3 35.3 0 0 1-35.2-35.3V134c0-16.5 13.5-26.7 35.2-26.7 22.8 0 35.3 9.4 35.3 26.7v25.7a35.3 35.3 0 0 1-35.3 35.2Zm0-85.7c-16 0-33.2 6.5-33.2 24.7v25.7a33.3 33.3 0 1 0 66.5 0V134c0-21.5-20.8-24.7-33.3-24.7Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M125.7 113.4a1 1 0 0 1-1-.6 14 14 0 0 1-1-4.5 22.5 22.5 0 0 1 22.4-22.4h.1a22.5 22.5 0 0 1 22.4 22.3 12.2 12.2 0 0 1-1 4.2 1 1 0 0 1-1.8-.7 10.2 10.2 0 0 0 .8-3.5 20.5 20.5 0 0 0-20.4-20.3h-.1a20.5 20.5 0 0 0-20.4 20.3 12 12 0 0 0 .9 3.9 1 1 0 0 1-1 1.3Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M247.7 108h-12a7 7 0 0 1 0-14h12a7 7 0 0 1 0 14ZM329.7 137.5h-12a7 7 0 0 1 0-14h12a7 7 0 0 1 0 14ZM367.7 137.5h-12a7 7 0 0 1 0-14h12a7 7 0 0 1 0 14ZM405.7 137.5h-12a7 7 0 0 1 0-14h12a7 7 0 0 1 0 14ZM330.7 108.5h-56a7 7 0 0 1 0-14h56a7 7 0 0 1 0 14ZM291.7 136.5h-56a7 7 0 0 1 0-14h56a7 7 0 0 1 0 14ZM401.7 108.5h-43a7 7 0 0 1 0-14h43a7 7 0 0 1 0 14ZM247.7 167h-12a7 7 0 0 1 0-14h12a7 7 0 0 1 0 14ZM330.7 167.5h-56a7 7 0 0 1 0-14h56a7 7 0 0 1 0 14ZM401.7 167.5h-43a7 7 0 0 1 0-14h43a7 7 0 0 1 0 14ZM382.7 191a7 7 0 0 1 7-7h12a7 7 0 0 1 0 14h-12a7 7 0 0 1-7-7ZM299.7 191.5a7 7 0 0 1 7-7h56a7 7 0 0 1 0 14h-56a7 7 0 0 1-7-7ZM228.7 191.5a7 7 0 0 1 7-7h43a7 7 0 0 1 0 14h-43a7 7 0 0 1-7-7Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixingBugs);
export default __webpack_public_path__ + "static/media/fixing-bugs.3286d1f68e80697095038415f74ddd47.svg";
export { ForwardRef as ReactComponent };